import { cn } from '@/lib/utils';

interface Props { count: number; className?: string; }

/** Pastille or présentielle. Rien si count ≤ 0. `className` = positionnement
 *  (overlay avatar : "absolute -top-1 -right-1" ; item menu : "ml-auto"). */
export function NotificationBadge({ count, className }: Props) {
  if (count <= 0) return null;
  return (
    <span aria-hidden className={cn(
      'min-w-[17px] h-[17px] px-1 flex items-center justify-center rounded-full',
      'bg-[#B8860B] text-white text-[10px] font-bold leading-none',
      className,
    )}>
      {count > 9 ? '9+' : count}
    </span>
  );
}
